<template>
  <div>
    <!-- Basic Details -->
    <basic-details
      :matter="$store.state.matterStore.currentmatter"
    ></basic-details>
    <!-- Case Status -->
    <div v-if="hasCaseDetails">
      <case-status
        :matter="$store.state.matterStore.currentmatter"
        :detail="$store.state.matterStore.currentmatter.case_details"
      ></case-status>
    </div>
    <!-- Category -->
    <div v-if="hasCategoryDetails">
      <category-details
        :matter="$store.state.matterStore.currentmatter"
      ></category-details>
    </div>
    <!-- Linked Matters -->
    <div v-if="hasLinkedMatters">
      <linked-matters
        :matter="$store.state.matterStore.currentmatter"
      ></linked-matters>
    </div>
    <!-- Peitioner & Respondent -->
    <div
    >
      <petitioner-respondents
        :matter="$store.state.matterStore.currentmatter"
      ></petitioner-respondents>
    </div>

    <!-- Copy Petition Details -->
    <div v-if="hasCopyPetitionDetails">
      <basic-table
        :data="$store.state.matterStore.currentmatter.copy_petition_details"
        :title="'Copy Petition Details'"
      ></basic-table>
    </div>

    <!-- Lower Court Details -->
    <div v-if="hasLowerCourtDetail">
      <basic-table
        :data="$store.state.matterStore.currentmatter.lower_court_detail"
        :title="'Lower Court Details'"
      ></basic-table>
    </div>

    <!-- FIR Details -->
    <div v-if="hasFirDetails">
      <basic-table
        :data="$store.state.matterStore.currentmatter.fir_details"
        :title="'FIR Details'"
      ></basic-table>
    </div>

    <!-- Impung Order Details -->
    <div v-if="hasImpungOrderDetail">
      <basic-table
        :data="$store.state.matterStore.currentmatter.impung_order_detail"
        :title="'Impung Order Details'"
      ></basic-table>
    </div>

    <!-- Complaint Details -->
    <div v-if="hasComplaintDetails">
      <basic-table
        :data="$store.state.matterStore.currentmatter.complaint_details"
        :title="'Complaint Details'"
      ></basic-table>
    </div>

    <!-- Lac Details -->
    <div v-if="hasLacDetail">
      <basic-table
        :data="$store.state.matterStore.currentmatter.lac_detail"
        :title="'Lac Details'"
      ></basic-table>
    </div>

    <!-- Listening History -->
    <div v-if="hasListingHistory">
      <listing-details
        :matter="$store.state.matterStore.currentmatter"
      ></listing-details>
    </div>
    <!-- Crime Details & Lower Court -->
    <b-row v-if="hasCrimeDic || hasLowerCourt">
      <!-- Crime Details -->
      <b-col
        class="col-12 col-md-6 mb-1"
        v-if="hasCrimeDic"
      >
        <crime-details
          :matter="$store.state.matterStore.currentmatter"
        ></crime-details>
      </b-col>
      <!-- Lower Court -->
      <b-col
        class="col-12 col-md-6 mb-1"
        v-if="hasLowerCourt"
      >
        <lower-court
          :matter="$store.state.matterStore.currentmatter"
        ></lower-court>
      </b-col>
    </b-row>
    <!-- IA Details -->
    <div v-if="hasIaDetails">
      <DynamicListTable
        :data="$store.state.matterStore.currentmatter.ia"
        title="IA Details"
      ></DynamicListTable>
    </div>
  </div>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
// Section Imports
import BasicDetails from './components/basic-details/BasicDetails.vue'
import CaseStatus from './components/status/CaseStatus.vue'
import ListingDetails from './components/listing-history/ListingDetails.vue'
import PetitionerRespondents from './components/petitioner-respondent/PetitionerRespondents.vue'
import DynamicListTable from './components/DynamicListTable.vue'
import CategoryDetails from './components/CategoryDetails.vue'
import LinkedMatters from './components/LinkedMatters.vue'
import LowerCourt from './components/LowerCourt.vue'
import CrimeDetails from './components/CrimeDetails.vue'
import BasicTable from './components/tables/BasicTable.vue'

export default {
  computed: {
    currentMatter() {
      return this.$store.state.matterStore.currentmatter || {}
    },
    hasCaseDetails() {
      return this.hasObjectData(this.currentMatter.case_details)
    },
    hasCategoryDetails() {
      return this.hasAnyData(this.currentMatter.category)
    },
    hasLinkedMatters() {
      return this.hasAnyData(this.currentMatter.linked_matters)
    },
    hasCopyPetitionDetails() {
      return this.hasAnyData(this.currentMatter.copy_petition_details)
    },
    hasLowerCourtDetail() {
      return this.hasAnyData(this.currentMatter.lower_court_detail)
    },
    hasFirDetails() {
      return this.hasAnyData(this.currentMatter.fir_details)
    },
    hasImpungOrderDetail() {
      return this.hasAnyData(this.currentMatter.impung_order_detail)
    },
    hasComplaintDetails() {
      return this.hasAnyData(this.currentMatter.complaint_details)
    },
    hasLacDetail() {
      return this.hasAnyData(this.currentMatter.lac_detail)
    },
    hasListingHistory() {
      return this.hasAnyData(this.currentMatter.listing_history)
    },
    hasCrimeDic() {
      return this.hasAnyData(this.currentMatter.crime_dic)
    },
    hasLowerCourt() {
      return this.hasAnyData(this.currentMatter.lower_court)
    },
    hasIaDetails() {
      return this.hasAnyData(this.currentMatter.ia)
    }
  },
  methods: {
    hasObjectData(value) {
      return (
        !!value &&
        typeof value === 'object' &&
        !Array.isArray(value) &&
        Object.keys(value).length > 0
      )
    },
    hasAnyData(value) {
      if (Array.isArray(value)) return value.length > 0
      if (value && typeof value === 'object') return Object.keys(value).length > 0
      return value !== null && value !== undefined && value !== ''
    }
  },
  components: {
    BRow,
    BCol,
    // Basic Details
    BasicDetails,
    CaseStatus,
    ListingDetails,
    PetitionerRespondents,
    DynamicListTable,
    CategoryDetails,
    LinkedMatters,
    LowerCourt,
    CrimeDetails,
    BasicTable
  }
}
</script>
